import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Swal from 'sweetalert2';

import SelectDates from './SelectDates.jsx';
import {
  InputDateWrapper,
  InputWrapper,
  Label,
  CustomInput,
  LinkButton,
  RemoveButton,
} from './StyledComponents';
import Modal from '../../../shared/Modal';
import TextInput from '../../../shared/FormStyles/TextInput.jsx';
import Tooltip from '../../../shared/Tooltip';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

const InformationIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-circle-info',
  }),
)`
  margin: 0 4px;
  padding-bottom: 2px;
`;

const PRIZE_LENGTH = 200;
const OTHER_LENGTH = 300;

const Calendar = styled.i.attrs(
  defaultAttrs({
    className: 'fa-light fa-calendar fa-lg',
  }),
)`
  color: ${props => (props.inputvalue.length > 0 ? '#007EFF' : '#CACCCF')};
`;

const selectDatesModal = (onDateChange, dateRange, t) => {
  const onSave = (dates, inputValue) => {
    onDateChange(dates, inputValue);
    Swal.close();
  };

  Modal({
    component: (
      <SelectDates
        onCancel={() => Swal.clickCancel()}
        onSave={onSave}
        initialDates={dateRange}
        title={t('prizes:form.dates')}
      />
    ),
    width: '394px',
    padding: '24px 0px 13px',
    showConfirmButton: false,
  });
};

const PrizeForm = ({
  isShow,
  values,
  handleChange,
  handleChangePrize,
  addPrize,
  removePrize,
  onDateChange,
  inputError,
}) => {
  const { t } = useTranslation(['prizes']);

  const dateRange = values.startsAt
    ? [new Date(values.startsAt), new Date(values.endsAt)]
    : [];

  return (
    <div className="new_raffle" id="new_raffle">
      <Tooltip />
      <Label>
        {t('prizes:form.dates')}
        <InformationIcon
          data-tip={t('prizes:form.datesTooltip')}
          data-offset="{ 'right': 100 }"
        />
      </Label>
      <InputDateWrapper
        onClick={() =>
          isShow ? null : selectDatesModal(onDateChange, dateRange, t)
        }
        variant={isShow ? 'disabled' : ''}
      >
        <CustomInput
          type="text"
          placeholder={t('prizes:form.datesPlaceholder')}
          value={values.dateInputValue}
          readOnly
          disabled={isShow}
        />
        <div style={{ margin: '0px 16px' }}>
          <Calendar inputvalue={values.dateInputValue} />
        </div>
      </InputDateWrapper>
      {values.prizes.map((_, index) => {
        return (
          <InputWrapper key={index}>
            {index > 0 && !isShow && (
              <RemoveButton
                onClick={() => {
                  removePrize(index);
                }}
              >
                {t('prizes:form.removePrize')}
              </RemoveButton>
            )}
            <TextInput
              label={t('prizes:form.prizeDescription')}
              charactersLimit={PRIZE_LENGTH}
              name="prizes"
              onChange={event => handleChangePrize(event, index)}
              value={values.prizes[index]}
              placeholder={t('prizes:form.prizeDescriptionPlaceholder')}
              disabled={isShow}
              error={inputError('prizes') && inputError('prizes')[index]}
            />
          </InputWrapper>
        );
      })}
      {
        <LinkButton
          disabled={isShow}
          onClick={() => {
            addPrize();
          }}
        >
          {t('prizes:form.addPrize')}
        </LinkButton>
      }
      <InputWrapper>
        <TextInput
          label={t('prizes:form.otherInfo')}
          name="otherInfo"
          onChange={handleChange}
          value={values.otherInfo}
          disabled={isShow}
          as="textarea"
          charactersLimit={OTHER_LENGTH}
        />
      </InputWrapper>
    </div>
  );
};

export default PrizeForm;
